// @ts-ignore
export function debounce(callback, threshold) {
    // @ts-ignore
    let timeoutHandle;

    return function () {
        // @ts-ignore
        let funcThis = this,
            args = arguments;

        // @ts-ignore
        clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(function () {
            timeoutHandle = null;
            callback.apply(funcThis, args);
        }, threshold);
    };
}
